/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BooleanServiceResult } from '../models/BooleanServiceResult';
import type { FolderUnitResponseServiceResult } from '../models/FolderUnitResponseServiceResult';
import type { ToggleGpsModeRequest } from '../models/ToggleGpsModeRequest';
import type { UnitDetailServiceResult } from '../models/UnitDetailServiceResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SleeperUnitInformationApiClient {

    /**
     * Used to get details of one or more sleeper units in a given folder by using an optional unit name search parameter.
     * @param folderId
     * @param unitName
     * @param pageCount
     * @param noOfRows
     * @returns FolderUnitResponseServiceResult Success
     * @throws ApiError
     */
    public static getApiV1UnitInFolder(
        folderId: number,
        unitName: string = '',
        pageCount: number = 1,
        noOfRows: number = 50,
    ): CancelablePromise<FolderUnitResponseServiceResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Unit/InFolder/{folderId}',
            path: {
                'folderId': folderId,
            },
            query: {
                'unitName': unitName,
                'pageCount': pageCount,
                'noOfRows': noOfRows,
            },
        });
    }

    /**
     * Used to get details of an individual sleeper unit by id value.
     * @param id
     * @returns UnitDetailServiceResult Success
     * @throws ApiError
     */
    public static getApiV1Unit(
        id: number,
    ): CancelablePromise<UnitDetailServiceResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/Unit/{Id}',
            path: {
                'Id': id,
            },
        });
    }

    /**
     * Used to toggle gps mode and update reporting frequency sleeper unit by id value.
     * @param id
     * @param requestBody
     * @returns BooleanServiceResult Success
     * @throws ApiError
     */
    public static postApiV1UnitToggleGpsMode(
        id: number,
        requestBody?: ToggleGpsModeRequest,
    ): CancelablePromise<BooleanServiceResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/Unit/ToggleGpsMode/{Id}',
            path: {
                'Id': id,
            },
            body: requestBody,
            mediaType: 'application/json-patch+json',
        });
    }

}
